import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const CAR: AppRouteRecordRaw = {
  path: '/car',
  name: 'car',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '汽车充电',
    icon: 'icon-car',
    requiresAuth: true,
    order: 6,
  },
  children: [
    {
      path: 'charging',
      name: 'CarCharging',
      component: () => import('@/layout/route-view.vue'),
      meta: {
        locale: '汽车充电',
        requiresAuth: true,
      },
      children: [
        {
          path: 'group',
          name: 'CarChargingGroup',
          component: () => import('@/views/car/charging/group/index.vue'),
          meta: {
            locale: '汽车充电站点',
            requiresAuth: true,
            roles: ['*'],
          },
        },
        {
          path: 'device',
          name: 'CarChargingDevice',
          component: () => import('@/views/station/device/index.vue'),
          meta: {
            locale: '汽车充电设备',
            requiresAuth: true,
            roles: ['*'],
            hideInMenu: true,
          },
        },
      ],
    },
  ],
};

export default CAR;
